import { AutoCompleteProps, Button, DatePicker, Input } from "antd";
import { api } from "../../../config";
import { AuthenticationState, UserInterface } from "../../../interfaces/users";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { addHours } from "date-fns";
import { useQuery } from "react-query";
import { Event } from "../RescheduleAssemblyEvent/RescheduleAssemblyEvent";
import { SearchAssemblers } from "../../Shared/Components/SearchAssemblers/SearchAssemblers";

interface SingleScheduleProps {
  onSuccess: (event: Event) => void;
  onCancel: () => void;
  refetch: () => void;
}

export const SingleSchedule = ({
  onSuccess,
  onCancel,
  refetch
}: SingleScheduleProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { data: assemblers } = useQuery<UserInterface[]>("users-assemble", () =>
    api(token).get(`/users?moduleName=ASSEMBLE_APP&permission=USER`)
  );
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<AutoCompleteProps["options"]>([]);
  const [newEvent, setNewEvent] = useState<Event>({
    start_time: undefined,
    end_time: undefined,
    assembler_id: undefined,
    description: undefined,
  });

  const [assembler, setAssembler] = useState<number | undefined>();

  useEffect(() => {
    console.log("assembler", assembler);
  }, [assembler]);

  const getPanelValue = (text: string) => {
    return assemblers
      ?.filter((user) =>
        user.fullName.toLowerCase().includes(text.toLowerCase())
      )
      .map((user) => ({ value: user.fullName, label: user.fullName }));
  };

  const onReschedule = () => {
    try {
      setLoading(true);

      if (!newEvent.start_time || !newEvent.end_time || !assembler)
        throw new Error("Preencha todos os campos");

      if (!assembler) throw new Error("Selecione um montador");

      api(token)
        .post(`events/assemble`, {
          start: newEvent.start_time,
          end: newEvent.end_time,
          assemblerId: assembler,
          description: newEvent.description
        })
        .then(() => {
          onSuccess && onSuccess(newEvent);
          toast.success("Agendamento realizado com sucesso!");
          refetch()
          handleClose()
        })
        .catch((error) => {
          console.log(error);
          toast.error("Ocorreu um erro ao realizar o agendamento");
        });
    } catch (error) {
      console.log(error);
      toast.error("Ocorreu um erro ao realizar o agendamento");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewEvent({
    start_time: undefined,
    end_time: undefined,
    assembler_id: undefined,
    description: undefined,
  })
    onCancel()
  }

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center gap-2">
          Horário de Início
          <DatePicker
            showTime
            format="DD/MM/YY HH:mm"
            minuteStep={15}
            allowClear={false}
            disabledDate={(date) => date.isBefore(new Date())}
            disabledTime={() => ({
              disabledHours: () => [0, 1, 2, 3, 4, 5, 22, 23],
            })}
            value={dayjs(newEvent.start_time)}
            onChange={(value) => {
              if (
                value &&
                (value.isAfter(new Date()) || value.isSame(new Date()))
              ) {
                setNewEvent({
                  ...newEvent,
                  start_time: value.toDate(),
                  end_time: addHours(value.toDate(), 6),
                });
              } else {
                if (value) {
                  toast.error("Data inválida");
                }
                setNewEvent({
                  ...newEvent,
                  start_time: null,
                  end_time: null,
                });
              }
            }}
          />
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          Horário Final
          <DatePicker
            showTime
            format="DD/MM/YY HH:mm"
            minuteStep={15}
            allowClear={false}
            disabledDate={(date) => date.isBefore(new Date())}
            disabledTime={() => ({
              disabledHours: () => [0, 1, 2, 3, 4, 5, 22, 23],
            })}
            onChange={(value) => {
              if (
                value &&
                (value.isAfter(new Date()) || value.isSame(new Date()))
              ) {
                setNewEvent({
                  ...newEvent,
                  end_time: value.toDate(),
                });
              } else {
                if (value) {
                  toast.error("Data inválida");
                }
                setNewEvent({
                  ...newEvent,
                  end_time: null,
                });
              }
            }}
            placeholder=""
            value={dayjs(newEvent.end_time)}
          />
        </div>

        <SearchAssemblers assembler={assembler} setAssembler={setAssembler} />

        <div>
          <label>Descrição</label>
          <Input
            onChange={(e) =>
              setNewEvent({ ...newEvent, description: e.target.value })
            }
          />
        </div>
      </div>
      <div className="flex  items-center justify-between gap-4">
        <Button className="mt-4" danger onClick={onCancel} loading={loading}>
          Cancelar
        </Button>
        <Button
          className="mt-4"
          type="primary"
          onClick={() => onReschedule()}
          loading={loading}
        >
          Agendar
        </Button>
      </div>
    </div>
  );
};
